import Joi from "joi";

export const ValidadePaymentMethods = (paymentMethod) => {
  const schema = Joi.object({
    cod: Joi.valid(
      '01', '02', '03', '04', '05',
      '10', '11', '12', '13', '14',
      '15', '16', '17', '18', '19', '90',
    ).required().messages({
      "any.required": "(Forma de pagamento) deve ser informada e correta!.",
      "any.empty": "(Forma de pagamento) deve ser informada e correta!.",
      "any.only": "(Forma de pagamento) deve ser informada e correta!."
    }),
    nome: Joi.string().max(255).required().messages({
      "string.empty": "(Descrição) deve ser informada.",
      "string.base": "(Descrição) deve ser informada.",
      'string.max': '(Descrição) deve conter no máximo 100 caracteres.',
      'any.required': '(Descrição) deve ser informada.'
    }),
    taxa: Joi.number().allow(null, ''),
    tipoTaxa: Joi.valid('porcentagem', 'monetario').required().messages({
      "any.only": "(Tipo taxa) deve ser 'Monetária' ou 'Porcentagem'."
    }),
    assumirTaxa: Joi.boolean().required(),
  }).unknown(true)

  const { error } = schema.validate(paymentMethod, {
    allowUnknown: true,
  })

  if (error?.details[0]?.message || error?.details[0]?.path[0]) {
    return {
      message: error?.details[0]?.message,
      keyError: error?.details[0]?.context?.key,
      positionItem: error?.details[0]?.path[1] !== undefined ? error?.details[0]?.path[1] : null
    }
  }
}